
const getNextMonthSameDayAndTime = ({day, hour, minute}) => {

        // Şu anki tarihi alın
        const now = new Date();
    
        // Yıl ve ay bilgilerini alın
        let year = now.getFullYear();
        let month = now.getMonth() + 1; // 0 tabanlı olduğu için 1 eklenir
    
        // Verilen gün, saat ve dakika bilgisi ile bir tarih oluşturun
        let candidateDate = new Date(year, month - 1, day, hour, minute);
    
        // Verilen gün geçerli değilse (örneğin 30 Şubat) veya tarih geçmişteyse kontrol edin
        if (candidateDate.getDate() !== day || candidateDate <= now) {
            // Ayı bir sonraki aya taşı
            month += 1;
    
            // Eğer Aralık ayını geçerse yıl güncelle
            if (month > 12) {
                month = 1;
                year += 1;
            }
    
            // Yeni tarih oluştur
            candidateDate = new Date(year, month - 1, day, hour, minute);
        }
    
        // Tarihi ISO formatında manuel olarak oluştur
        const formattedYear = candidateDate.getFullYear();
        const formattedMonth = (candidateDate.getMonth() + 1).toString().padStart(2, '0'); // Aylar 0 tabanlıdır
        const formattedDay = candidateDate.getDate().toString().padStart(2, '0');
        const formattedHour = candidateDate.getHours().toString().padStart(2, '0');
        const formattedMinute = candidateDate.getMinutes().toString().padStart(2, '0');
        const formattedSecond = candidateDate.getSeconds().toString().padStart(2, '0');
        const formattedMillisecond = candidateDate.getMilliseconds().toString().padStart(3, '0');
    
        return `${formattedYear}-${formattedMonth}-${formattedDay}T${formattedHour}:${formattedMinute}:${formattedSecond}.${formattedMillisecond}`;
}

export default getNextMonthSameDayAndTime
